import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import DanhSachTaiSanApi from "../../../../service/danhSachTaiSanApi";
import { useDispatch, useSelector } from "react-redux";
import { getListTaiSan, updateDataSearch } from "actions/DanhSachTaiSan/";
import { pushNotification } from "utils/notifications";

export const SoHuu = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const dispatch = useDispatch();
  const thongTinTaiSan = {
    STT: "",
    Code: "",
    TenTaiSan: "",
    Note: "",
    PhiKho: "",
  };
  const [thongTinTaiSanValue, setThongTinTaiSan] = useState(thongTinTaiSan);
  useEffect(() => {
    DanhSachTaiSanApi.getOneDetailTaiSan(props.taiSanId).then((response) => {
      setThongTinTaiSan(response.data.ThongTinTaiSan);
    });
  }, []);

  const onSubmit = () => {
    // console.log(props);
    DanhSachTaiSanApi.soHuu(props.taiSanId).then((response) => {
      pushNotification(
        "Chuyển trạng thái thành công",
        "success",
        "TOP_CENTER",
        1000
      );
      props.onHide();
      // showAlert();
      dispatch(getListTaiSan(dataSearch));
    });
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/logo-so-huu.png" />
          </span>{" "}
          Sở hữu
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form class="form tat-toan">
          <div class="form-body">
            <div class="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse5612"
                class="card-header"
                href="#collapse5612"
                aria-expanded="true"
                aria-controls="collapse5612"
              >
                <a class="card-title lead info collapsed" href={() => false}>
                  <h3>Thông tin tài sản</h3>
                </a>
              </div>
              <div
                id="collapse5612"
                aria-labelledby="headingCollapse5612"
                class="card-collapse collapse show"
                aria-expanded="true"
              >
                <div class="card-content">
                  <div class="card-body">
                    <div class="table-responsive table-2">
                      <table class="table table-bordered mb-0">
                        <thead>
                          <tr className="header-v2">
                            <th>STT</th>
                            <th>Mã tài sản</th>
                            <th>Tên tài sản</th>
                            <th>Ghi chú</th>
                            <th>Phí kho</th>
                          </tr>
                        </thead>
                        <tbody>
                          {" "}
                          <tr class="active">
                            <th scope="row">1</th>
                            <td>{thongTinTaiSanValue.Code}</td>
                            <td>{thongTinTaiSanValue.TenTaiSan}</td>
                            <td>{thongTinTaiSanValue.Note}</td>
                            <td>0</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="alert alert-danger mt-1" role="alert">
                      <span class="canh-bao">
                        Bạn có chắc chắn muốn chuyển trạng thái{" "}
                        <span class="blue">Cần thanh lý</span> sang trạng thái{" "}
                        <span class="blue">Sở hữu</span> không?{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSubmit}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>{" "}
          &nbsp; Xác nhận&nbsp;
        </button>
      </Modal.Footer>
    </Modal>
  );
};
